/**
 * SiteHeader Organism Component
 * Main header matching Elementor structure (aa45398, fa4e53e)
 */

'use client'

import { Marquee } from '@/components/atoms/Marquee'
import { NavMenu } from '@/components/molecules/NavMenu'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'

interface SiteHeaderProps {
	className?: string
}

const marqueeItems = [
	'Tattersall Colombia',
	'Innovación en movilidad con una flota que se renueva contigo',
]

const navItems = [
	{ label: 'Inicio', href: '/' },
	{ label: 'Nosotros', href: 'https://tattersall.com.co/nosotros/' },
	{ label: 'Nuestra<br> flota', href: 'https://tattersall.com.co/nuestra-flota', multiline: true },
	{ label: 'Para<br> empresas', href: 'https://tattersall.com.co/para-empresas', multiline: true },
	{ label: 'Para<br> personas', href: 'https://tattersall.com.co/para-personas', multiline: true },
	{ label: 'Sucursales', href: 'https://tattersall.com.co/sucursales' },
	{ label: 'Blog', href: 'https://tattersall.com.co/blog' },
	{
		label: 'Haz tu<br>reserva aquí',
		href: '/',
		multiline: true,
		external: true,
	},
]

export function SiteHeader({ className }: SiteHeaderProps) {
	return (
		<header className={cn('w-full flex flex-col p-0', className)}>
			{/* Marquee Banner - elementor-element-aa45398 */}
			<Marquee
				items={marqueeItems}
				speed={100}
				pauseOnHover={true}
			/>

			{/* Main Navigation Container - elementor-element-fa4e53e */}
			<div className='flex flex-row justify-between items-center bg-[#09194D] py-[2%] px-[3%] md:py-[2%] md:px-[3%] max-md:py-[3%] max-md:px-[3%]'>
				{/* Logo - elementor-element-4b92849 */}
				<Link
					href='/'
					className='shrink-0 w-[62%] md:w-[24%] max-w-[62%] md:max-w-[24%]'
				>
					<Image
						src='/images/logo.svg'
						alt='Tattersall Colombia'
						width={200}
						height={37}
						priority
						className='w-full h-auto'
					/>
				</Link>

				{/* Navigation Menu - elementor-element-3d40687 */}
				<NavMenu
					items={navItems}
				/>
			</div>
		</header>
	)
}
